// extracted by mini-css-extract-plugin
module.exports = {"fileWrapper":"FileUpload_fileWrapper__3IDcR","bytes":"FileUpload_bytes__1-zgv","error":"FileUpload_error__1BX2E"};